import styled from 'styled-components';
import { BODY_AREA, type IntrinsicAttributes } from './constants';

// Srollable area of the sidebar content. If a footer is present, this will scroll independently of the footer.
// Use of this component is optional, but if a footer is present, this must be used to wrap the main body content to ensure the footer is always visible.
export const SidebarContentScrollable = styled.div.attrs<IntrinsicAttributes>(
    (props) => ({
        'data-test': props['data-test'] ?? 'sidebar-content-scrollable',
    })
)`
    flex: 0 1 auto;
    min-height: 0;
    overflow-y: auto;
`;

// Footer area of the sidebar content.
// If present, this will be pinned to the bottom of the sidebar and will not scroll with the body,
// but will expand in height as needed.
export const SidebarContentFooter = styled.div.attrs<IntrinsicAttributes>(
    (props) => ({
        'data-test': props['data-test'] ?? 'sidebar-content-footer',
    })
)`
    flex: 1 0 auto;
    min-height: fit-content;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
`;

// Main body of the sidebar content.
// This will scroll if the content exceeds the available height,
// but will collapse if a footer is present to allow the footer to be visible.
export const SidebarContentBody = styled.div.attrs<IntrinsicAttributes>(
    (props) => ({ 'data-test': props['data-test'] ?? 'sidebar-content-body' })
)`
    grid-area: ${BODY_AREA};
    min-height: 0;
    flex-grow: 1;
    overflow-y: auto;

    &:has(${SidebarContentFooter}) {
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    &:has(${SidebarContentFooter}) > ${SidebarContentScrollable} {
        overflow-y: auto;
    }
`;
